import type { Condition, Text, Value, Values } from "./types.js";

export function isFilled(v: Value): boolean {
  if (v === undefined || v === null) return false;
  if (typeof v === "boolean") return v;
  return v.trim().length > 0;
}

function asComparable(v: Value): string | boolean {
  if (typeof v === "boolean") return v;
  return (v ?? "").trim();
}

export function evalCondition(c: Condition, values: Values): boolean {
  if ("all" in c) return c.all.every((x) => evalCondition(x, values));
  if ("any" in c) return c.any.some((x) => evalCondition(x, values));
  if ("not" in c) return !evalCondition(c.not, values);
  const v = values[c.field];
  if ("equals" in c) return asComparable(v) === c.equals;
  if ("notEquals" in c) return asComparable(v) !== c.notEquals;
  if ("in" in c) return c.in.includes(String(asComparable(v)));
  if ("notIn" in c) return !c.notIn.includes(String(asComparable(v)));
  if ("filled" in c) return isFilled(v);
  if ("empty" in c) return !isFilled(v);
  return false;
}

export function resolveText(t: Text | undefined, values: Values): string {
  if (t === undefined) return "";
  if (typeof t === "string") return t;
  const hit = t.cases.find((c) => evalCondition(c.when, values));
  return hit ? hit.text : t.default;
}
